import * as R from 'ramda';

import { getFieldLocale } from '@/utils/field';

export default {
    name: 'BreakdownTranslatorMixin',
    computed: {},
    methods: {
        /**
         * 메인 함수
         */
        getBreakdownName(breakdown) {
            const { id, name, locale: localeFromBE } = breakdown;

            const isCustom = R.is(Number, id);

            return isCustom
                ? name
                : localeFromBE || getFieldLocale.call(this, name);
        },
    },
};
